@if (model.data) {
<div class="pos-relative">
    <carousel class="_carousel"
              [slidesPerView]="1"
              [pagination]="{clickable: true}"
              [loop]="images.length > 1"
              [navigation]="{
                         nextEl: '.outfit-preview-next',
                         prevEl: '.outfit-preview-prev'
                    }">
        @for (item of images; track $index) {
        <ng-template swiperSlide>
            <div class="w-12 center">
                <div class="w-9 ratio-3-4">
                    <img class="rf"
                         [image]="item.image" />
                </div>
            </div>
        </ng-template>
        }
        @if (images.length > 1) {
        <div slot="container-start">
            <button class="pos-absolute top-50 left-2 z-5 outfit-preview-prev"
                    type="button"
                    [attr.aria-label]="'Previous slide' | translate">
                <i class="icon-chevron-left"
                   style="font-size: 12px;"
                   aria-hidden="true"></i>
            </button>
            <button class="pos-absolute top-50 right-2 z-5 outfit-preview-next"
                    type="button"
                    [attr.aria-label]="'Next slide' | translate">
                <i class="icon-chevron-right"
                   style="font-size: 12px;"
                   aria-hidden="true"></i>
            </button>
        </div>
        }
    </carousel>
    <div class="flex m-t">
        <p class="h3">{{model.name}}</p>
        <div class="flex-grow"></div>
        <!-- final price -->
        <price class="h3 col-11 m-r-2"
               [value]="model.getPrice()"></price>
        <!-- org price for discount -->
        @if (model.getOrgPrice()) {
        <price class="h3 col-12 line-through"
               [value]="model.getOrgPrice()"></price>
        }
    </div>
    <!-- configurable options -->
    <!-- [data]="curentSelectionData" -->
    @if (model.isConfigurable) {
    <builder-product-configurable-options class="block"
                                          [product]="originalModel!"
                                          [familyAttrs]="['color']"
                                          [data]="selection!"
                                          [preselectSingles]="true"
                                          [preselectOptions]="['color']"
                                          (selectionChange)="onSelectionChange($event.data)"
                                          (init)="onSelectionChange($event.data)">
    </builder-product-configurable-options>
    }
    <!-- product page -->
    <href class="block button-inline-5 inline m-t p1"
          [hrefTarget]="'_blank'"
          [link]="model.data.url">
        {{'View product page' | translate}}
    </href>
</div>
}